import { Drawer, } from '@material-ui/core';

import NewChamadoComponent from '../../components/Chamados/newChamado';


export default function NewChamado({show, onClose}) {
  return (
    <Drawer
      anchor='bottom'
      open={show}
      onClose={onClose}
    >
      <NewChamadoComponent onClose={onClose}/>
    </Drawer>
  );
}
